/**
 * The action row every dialog, alert dialog and sheet footer shares.
 *
 * ON A PHONE THE CLOSING PAIR SITS SIDE BY SIDE IN EQUAL HALVES — PropPay's
 * footer (B4, 2026-09-28). It used to stack full width, primary on top, which
 * spent two rows of a phone's scarce height on "Cancel" and "Save" and put the
 * primary at the far end of the thumb's reach. Side by side, the pair is one
 * row and the primary is on the right, where it is on a desk.
 *
 * `flex-1` is on direct BUTTONS (and links) only, never `[&>*]`: a few footers
 * pass a wrapper div with their own `justify-between` (the account sheet's
 * Sign out on the left, Save on the right) and those must keep laying
 * themselves out. `min-width` stays `auto`, so a label that does not fit its
 * half widens its button instead of overflowing it, and `flex-wrap` sends a
 * third button that does not fit onto a full-width row of its own rather than
 * running off the screen — the primary, being last, is the one that gets it.
 * It wraps on a desk too: three buttons in a `sm` card overflowed its padding.
 * A secondary action that belongs APART from the pair goes in `start`.
 *
 * The ⋯ More trigger (OverflowMenu, `data-overflow-trigger`) is NOT one of
 * the pair: it keeps its own square, touch-sized box. Before 2026-10-27 it
 * took `flex-1` like any button and stretched to 152×36 beside the primary on
 * a phone. The attribute rule is a class plus an attribute, (0,2,0), so it
 * beats `[&>button]:flex-1`, (0,1,1).
 *
 * The phone layout is the base and `sm:` restores the desk. (Written that way
 * when Tailwind 3's raw screens switched the `max-*` variants off; Tailwind 4
 * generates them, but base-plus-`sm:` is still the one direction to read.)
 */
export const dialogActionRow = [
  "flex flex-row flex-wrap items-stretch gap-2",
  "sm:items-center sm:justify-end",
  "[&>button]:flex-1 [&>a]:flex-1 sm:[&>button]:flex-none sm:[&>a]:flex-none",
  "[&>[data-overflow-trigger]]:flex-none",
].join(" ")

/**
 * The ⋯ More trigger beside a row of real buttons — the sales toolbar's and
 * every record window's: outlined, 36px on a desk, the touch minimum on a
 * coarse pointer. Pass it with `variant="outline"` so there is one ⋯ style.
 */
export const MORE_TRIGGER = "h-10 w-10 touch:min-h-touch touch:min-w-touch";
